import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=c585600a&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=c585600a&prod&scoped=true&lang=css"
import style1 from "./Admin.vue?vue&type=style&index=1&id=c585600a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c585600a",
  null
  
)

export default component.exports